/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerscolumnname2Inputs */

const en_partnerscolumnname2 = /** @type {(inputs: Partnerscolumnname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partner`)
};

const de_partnerscolumnname2 = /** @type {(inputs: Partnerscolumnname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partner`)
};

/**
* | output |
* | --- |
* | "Partner" |
*
* @param {Partnerscolumnname2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerscolumnname2 = /** @type {((inputs?: Partnerscolumnname2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerscolumnname2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerscolumnname2(inputs)
	return de_partnerscolumnname2(inputs)
});
export { partnerscolumnname2 as "partnersColumnName" }